module.exports = __webpack_public_path__ + "img/faceberry_edit_guide.c495a4ba.png";